import { render } from "./DataExport.vue?vue&type=template&id=2d84e3d8"
import script from "./DataExport.js?vue&type=script&lang=js"
export * from "./DataExport.js?vue&type=script&lang=js"

import "./DataExport.vue?vue&type=style&index=0&id=2d84e3d8&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__